import { render } from "./PhotoBanner.vue?vue&type=template&id=4f87fee0&scoped=true"
import script from "./PhotoBanner.vue?vue&type=script&lang=js"
export * from "./PhotoBanner.vue?vue&type=script&lang=js"

import "./PhotoBanner.vue?vue&type=style&index=0&id=4f87fee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f87fee0"]])

export default __exports__